const names = [
  'Isaiah Sher',
  'Roxana Parker',
  'Latoya Crepeau',
  'Gwenda Mccaffery',
  'Tenesha Fogal',
  'Ewa Phares',
  'Margarete Rezac',
  'Otilia Lafler',
  'Juan Vogel',
  'Rogelio Renfrew',
  'Ginger Digiacomo',
  'Marilyn Pettyjohn',
  'Rolanda Hornback',
  'Rodger Ulloa',
  'Veta Hutton',
  'Lindsay Dubay',
  'Guy Schroer',
  'Indira Panzer',
  'Fredrick Thorn',
  'Marshall Gamache',
  'Michiko Gundlach',
  'Drema Inskeep',
  'Samatha Reves',
  'Jan Goates',
  'Tamala Worley',
  'Scot Doyon',
  'Marc Deans',
  'Charlsie Sigman',
  'Edward Larsen',
  'Stephan Alber',
  'Augustus Cothern',
  'Lakita Millwood',
  'Jared Hodgkinson',
  'Cher Aceto',
  'Kamala Tremble',
  'Hilda Slusser',
  'Angel Dano',
  'Aurelia Okelley',
  'Randall Boettcher',
  'Sparkle Eidson',
  'Carolina Heffington',
  'Adeline Pundt',
  'Brandon Dorrough',
  'Cecil Zufelt',
  'Johnette Harkness',
  'Julianne Rosenfield',
  'Latina Woodworth',
  'Lana Esquilin',
  'Dierdre Utsey',
  'Verona Brockett'
]

const shortNames = ['BASE', 'LOAN', 'CHECKING', 'OPERATING', 'BROKERAGE']

function random(max: number) {
  // Use crypto.getRandomValues() for cryptographically secure randomness
  const array = new Uint32Array(1)
  crypto.getRandomValues(array)
  return Math.floor((array[0] / (0xffffffff + 1)) * max)
}

export const getRandomName = () => names[random(names.length)]

export const getRandomShortName = () => shortNames[random(shortNames.length)]

export const getRandomCapitalLetter = () => {
  // Use crypto.getRandomValues() for cryptographically secure randomness
  const array = new Uint8Array(1)
  crypto.getRandomValues(array)
  return String.fromCharCode(65 + (array[0] % 26))
}
